import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["name", "teamNameInput", "logo", "logoPlaceholder"];
  static values = { existingLogoUrl: String }

  connect() {
    this.setTeamName()
    this.loadExistingLogo()
  }

  loadExistingLogo() {
    if (this.existingLogoUrlValue && this.existingLogoUrlValue !== "") {
      // Set the logo URL
      this.logoTarget.setAttribute("href", this.existingLogoUrlValue)
      this.logoTarget.style.display = "block"

      // Hide the placeholder
      if (this.hasLogoPlaceholderTarget) {
        this.logoPlaceholderTarget.style.display = "none"
      }
    }
  }

  setTeamName() {
    const value = this.teamNameInputTarget.value || "Team Name Goes Here"
    this.nameTarget.textContent = value.toUpperCase()
  }

  setTeamLogo(event) {
    // Get the file input (event.target is the input that triggered the event)
    const input = event.target
    const file = input.files[0]

    if (!file) return

    // Create a local URL from the file to display as preview
    const reader = new FileReader()
    reader.onload = (e) => {
      // Set the image href to the local file URL for preview
      this.logoTarget.setAttribute("href", e.target.result)

      // Show the image
      this.logoTarget.style.display = "block"

      // Hide the placeholder
      if (this.hasLogoPlaceholderTarget) {
        this.logoPlaceholderTarget.style.display = "none"
      }
    }
    reader.readAsDataURL(file)
  }

  clearTeamLogo() {
    // Hide the logo image
    this.logoTarget.style.display = "none"
    this.logoTarget.setAttribute("href", "")

    // Show the placeholder
    if (this.hasLogoPlaceholderTarget) {
      this.logoPlaceholderTarget.style.display = "block"
    }
  }
}
